import { fork, all } from 'redux-saga/effects';
import checkoutComponentSagas from 'yoda-checkout-components/lib/sagas';
import { watchFindMoreStoresRequest } from 'yoda-site-components/lib/sagas/FindStoresSaga';
import watchPlccDynamicBannerSaga from 'yoda-site-components/lib/sagas/PlccDynamicBannerSaga';
import {
    watchApplyAdjustmentsRequest,
    watchRemoveAdjustmentsRequest,
    watchgetAppliedAdjustmentsRequest,
    watchgetEmptyAdjustmentsRequest,
} from 'yoda-site-components/lib/sagas/AdjustmentSaga';
import {
    watchAccertifyDeviceInfo,
    watchLogExtendedAnalytics,
} from 'yoda-site-components/lib/sagas/SiteProbingSaga';
import watchSYFQuickScreenSaga from 'yoda-account-components/lib/sagas/SYFQuickScreenSaga';
import watchLastOrder from './OrderConfirmationSaga';
import {
    watchCreateAccountPostOrder,
    watchGetAccountByEmail,
    watchEnrollRewardlink,
    watchNativeCreateAccountFailure,
} from './CreateAccountPostOrderSaga';
import watchCreateSessionPostOrder from './CreateSessionPostOrderSaga';
import watchStoreInfoSaga from './StoreInfoSaga';
import watchExpressCheckoutSaga from './ExpressCheckoutSaga';

import {
    watchSubmitShippingAddress,
    watchGetAddressList,
    watchGetAddressListWithGR,
    watchAddressTypeChange,
    watchShippingGroupInfoChange,
} from './ShippingAddressSaga';
import { watchCartDetails, watchGetProfileInfo } from './CartDetailsSaga';
import {
    watchGetPromoFinancingSaga,
    watchPatchSelectedPromoFinancingSaga,
    watchpostSelectedRewardOrFinancingSaga,
} from './PaymentSaga';
import watchAddPayPalPaymentType from './AddPayPalPaymentTypeSaga';
import { watchGetShippableStores } from './ShipToStoreSaga';
import {
    watchSubmitNewPaymentRequest,
    watchInitNewPaymentInitRequest,
    watchDeleteUserPaymentNewPaymentRequest,
    watchUpdateUserPaymentNewPaymentRequest,
    watchRemoveGiftCardNewPaymentRequest,
    watchSubmitGiftCardNewPaymentRequest,
    watchAppWalletSubmitGiftCardRequest,
    watchUpdatePaypalContactInfoRequest,
    watchPollGCBalanceInfo,
    watchAppGCBalance,
    watchAppGiftcards,
    watchAppGCList,
    watchHandleChangePaymentMethodType,
    watchAddBnplToOrder,
} from './NewPaymentSaga';
import { watchSubmitBOPISSection } from './NewBOPISSaga';
import {
    watchInitNewShippingSection,
    watchSubmitNewSTHAddressForm,
    watchSubmitNewShippingSection,
    watchFetchCityStateByZip,
    watchDeleteShippingAddressFromProfile,
    watchChangeShippingAddressRequest,
    watchAddStoreToProfileRequest,
    watchUpdateShippingType,
    watchChangeShippingAddressOnCancel,
    watchRemoveRestrictedItem,
    watchChangeShipingAddress,
    watchChangeStoreAddress,
    watchUpdateSTHShippingSelection,
    // watchGetBnplAddress,
} from './NewShippingSaga';
import watchInitCheckoutSectionFromClientSideActions from './NewCheckoutSaga';
import watchBnplSectionSaga from './BNPLSectionSaga';

const checkoutComponentSagaList = Object.values(checkoutComponentSagas.injectedSagas);
const productSagas = [
    watchLastOrder,
    watchCreateAccountPostOrder,
    watchGetAccountByEmail,
    watchCreateSessionPostOrder,
    watchEnrollRewardlink,
    watchStoreInfoSaga,
    watchCartDetails,
    watchGetProfileInfo,
    watchSubmitShippingAddress,
    watchGetAddressList,
    watchAddPayPalPaymentType,
    watchGetPromoFinancingSaga,
    watchPatchSelectedPromoFinancingSaga,
    watchpostSelectedRewardOrFinancingSaga,
    watchGetShippableStores,
    watchGetAddressListWithGR,
    watchAddressTypeChange,
    watchShippingGroupInfoChange,
    watchExpressCheckoutSaga,
    watchInitNewPaymentInitRequest,
    watchSubmitNewPaymentRequest,
    watchDeleteUserPaymentNewPaymentRequest,
    watchUpdateUserPaymentNewPaymentRequest,
    watchUpdatePaypalContactInfoRequest,
    watchPollGCBalanceInfo,
    watchAppGCBalance,
    watchAppGiftcards,
    watchAppGCList,
    watchHandleChangePaymentMethodType,
    watchRemoveGiftCardNewPaymentRequest,
    watchSubmitGiftCardNewPaymentRequest,
    watchAppWalletSubmitGiftCardRequest,
    watchSubmitBOPISSection,
    watchInitNewShippingSection,
    watchSubmitNewSTHAddressForm,
    watchSubmitNewShippingSection,
    watchFetchCityStateByZip,
    watchDeleteShippingAddressFromProfile,
    watchChangeShippingAddressRequest,
    watchAddStoreToProfileRequest,
    watchUpdateShippingType,
    watchChangeShippingAddressOnCancel,
    watchRemoveRestrictedItem,
    watchChangeShipingAddress,
    watchChangeStoreAddress,
    watchUpdateSTHShippingSelection,
    watchInitCheckoutSectionFromClientSideActions,
    watchAccertifyDeviceInfo,
    watchLogExtendedAnalytics,
    watchNativeCreateAccountFailure,
    watchSYFQuickScreenSaga,
    watchAddBnplToOrder,
    // watchGetBnplAddress,
    /**
     * cart, pdp, checkout - find store component
     * yoda-microsite-cart/src/components/ItemFulfillmentsNew/ShowDetailedFulfillments/ShowDetailedFulfillments.jsx
     * yoda-microsite-cart/src/containers/Pages/Cart/CartPageWrapper/CartPageWrapper.jsx
     * yoda-microsite-pdp/src/components/AddToCart/AddToCart.jsx
     * yoda-microsite-checkout/src/containers/Pages/NewShippingPage/ShipToStoreContainer/ChangeStoreOptions/ChangeStoreOptions.jsx
     * yoda-microsite-pdp/src/components/DeliveryOption/DeliveryOption.jsx
     */
    // watchFindStoresRequest,
    /**
     * checkout - find store component
     * yoda-microsite-checkout/src/containers/Pages/NewShippingPage/ShipToStoreContainer/ChangeStoreOptions/ChangeStoreOptions.jsx
     */
    watchFindMoreStoresRequest,
    /**
     * coupon, cart, checkout, header/footer - coupon application
     * yoda-microsite-cart/src/containers/Pages/Cart/CartPageWrapper/CartPageWrapper.jsx
     * yoda-microsite-cart/src/containers/Pages/Cart/CartPage.jsx
     * yoda-microsite-checkout/src/containers/Pages/NewCheckoutPage/NewCheckoutPage.jsx
     * yoda-microsite-checkout/src/containers/Pages/Review/ReviewPage.jsx
     * yoda-microsite-checkout/src/containers/Pages/Review/ReviewPage.jsx
     * yoda-microsite-cart/src/containers/Pages/Cart/LazyModules/CartPageModalsLazy.jsx
     * Coupon page IRIS component "couponlist"
     * yoda-site-components/src/components/CouponDrawer/CouponDrawerAsync.jsx
     */
    watchApplyAdjustmentsRequest,
    /**
     * coupon, cart, checkout, header/footer - coupon application
     * yoda-microsite-cart/src/containers/Pages/Cart/CartPageWrapper/CartPageWrapper.jsx
     * yoda-microsite-cart/src/containers/Pages/Cart/CartPage.jsx
     * yoda-microsite-checkout/src/containers/Pages/NewCheckoutPage/NewCheckoutPage.jsx
     * yoda-microsite-checkout/src/containers/Pages/Review/ReviewPage.jsx
     * yoda-microsite-checkout/src/containers/Pages/Review/ReviewPage.jsx
     * yoda-microsite-cart/src/containers/Pages/Cart/LazyModules/CartPageModalsLazy.jsx
     * Coupon page IRIS component "couponlist"
     * yoda-site-components/src/components/CouponDrawer/CouponDrawerAsync.jsx
     */
    watchRemoveAdjustmentsRequest,
    /**
     * coupon, cart, checkout, header/footer - coupon get
     * yoda-microsite-cart/src/containers/Pages/Cart/CartPageWrapper/CartPageWrapper.jsx
     * yoda-microsite-cart/src/containers/Pages/Cart/CartPage.jsx
     * yoda-microsite-checkout/src/containers/Pages/NewCheckoutPage/NewCheckoutPage.jsx
     * yoda-microsite-checkout/src/containers/Pages/Review/ReviewPage.jsx
     * yoda-microsite-checkout/src/containers/Pages/Review/ReviewPage.jsx
     * yoda-microsite-cart/src/containers/Pages/Cart/LazyModules/CartPageModalsLazy.jsx
     * Coupon page IRIS component "couponlist"
     * yoda-site-components/src/components/CouponDrawer/CouponDrawerAsync.jsx
     */
    watchgetAppliedAdjustmentsRequest,
    /**
     * coupon, cart, checkout, header/footer - coupon application
     * yoda-microsite-cart/src/containers/Pages/Cart/CartPageWrapper/CartPageWrapper.jsx
     * yoda-microsite-cart/src/containers/Pages/Cart/CartPage.jsx
     * yoda-microsite-checkout/src/containers/Pages/NewCheckoutPage/NewCheckoutPage.jsx
     * yoda-microsite-checkout/src/containers/Pages/Review/ReviewPage.jsx
     * yoda-microsite-checkout/src/containers/Pages/Review/ReviewPage.jsx
     * yoda-microsite-cart/src/containers/Pages/Cart/LazyModules/CartPageModalsLazy.jsx
     * Coupon page IRIS component "couponlist"
     * yoda-site-components/src/components/CouponDrawer/CouponDrawerAsync.jsx
     */
    watchgetEmptyAdjustmentsRequest,
    watchPlccDynamicBannerSaga,
    watchBnplSectionSaga,
    ...checkoutComponentSagaList,
];

const injectedSagas = {};
for (const saga of productSagas) { // eslint-disable-line
    // 1. Check that every saga has a name
    if (!saga.sagaName) {
        throw new Error(
            `Every saga has to have sagaName property. For debug purposes: ${saga.toString()}`
        );
    }

    // 2. Check that we have only unique sagas (one could be from components, another the same one from shared)
    if (injectedSagas[saga.sagaName]) {
        throw new Error(
            `That saga ${saga.sagaName} was already registered. Only 1 instance for particular name is allowed`
        );
    }
    injectedSagas[saga.sagaName] = saga;
}

const productRootSaga = function* productRootSaga() {
    yield all(Object.values(injectedSagas).map((saga) => fork(saga)));
};

productRootSaga.injectedSagas = injectedSagas;

export default productRootSaga;
